export default __webpack_public_path__ + "static/media/clutch-ignition-protectors.25a85802.mp4";